
/*!
 * jQuery-ajaxTransport-XDomainRequest - v1.0.4 - 2015-03-05
 * https://github.com/MoonScript/jQuery-ajaxTransport-XDomainRequest
 * Copyright (c) 2015 Jason Moon (@JSONMOON)
 * Licensed MIT (/blob/master/LICENSE.txt)
*/

(function(a){if(typeof define==='function'&&define.amd){define(['jquery'],a)}else if(typeof exports==='object'){module.exports=a(require('jquery'))}else{a(jQuery)}}(function($){if($.support.cors||!$.ajaxTransport||!window.XDomainRequest){return $}var n=/^(https?:)?\/\//i;var o=/^get|post$/i;var p=new RegExp('^(\/\/|'+location.protocol+')','i');$.ajaxTransport('* text html xml json',function(j,k,l){if(!j.crossDomain||!j.async||!o.test(j.type)||!n.test(j.url)||!p.test(j.url)){return}var m=null;return{send:function(f,g){var h='';var i=(k.dataType||'').toLowerCase();m=new XDomainRequest();if(/^\d+$/.test(k.timeout)){m.timeout=k.timeout}m.ontimeout=function(){g(500,'timeout')};m.onload=function(){var a='Content-Length: '+m.responseText.length+'\r\nContent-Type: '+m.contentType;var b={code:200,message:'success'};var c={text:m.responseText};try{if(i==='html'||/text\/html/i.test(m.contentType)){c.html=m.responseText}else if(i==='json'||(i!=='text'&&/\/json/i.test(m.contentType))){try{c.json=$.parseJSON(m.responseText)}catch(e){b.code=500;b.message='parseerror'}}else if(i==='xml'||(i!=='text'&&/\/xml/i.test(m.contentType))){var d=new ActiveXObject('Microsoft.XMLDOM');d.async=false;try{d.loadXML(m.responseText)}catch(e){d=undefined}if(!d||!d.documentElement||d.getElementsByTagName('parsererror').length){b.code=500;b.message='parseerror';throw'Invalid XML: '+m.responseText;}c.xml=d}}catch(parseMessage){throw parseMessage;}finally{g(b.code,b.message,c,a)}};m.onprogress=function(){};m.onerror=function(){g(500,'error',{text:m.responseText})};if(k.data){h=($.type(k.data)==='string')?k.data:$.param(k.data)}m.open(j.type,j.url);m.send(h)},abort:function(){if(m){m.abort()}}}});return $}));

$(function() {

    var key = $('meta[name=api_key]');
    $.ajaxSetup({headers: {"api-key": key ? key.attr('content') : ''}});

    $('#submit-form').attr('disabled');
    var hash = window.location.hash.substr(1);
    if(!isNaN(parseInt(hash)) && isFinite(hash) && parseInt(hash) > 1) {
        window.location = '/registration';
    }
    
    var qs = document.URL.split('?');
    var date_id = (qs.length == 2) ? qs[1].split('=')[1] : null;

    var api_url = $('meta[name=api_url]').attr('content');
    var event_id = $('meta[name=event_id]').attr('content');
    var date_id;
    var delegate_id = $('meta[name=delegate_id]').attr('content');
    var csrf_token = $('meta[name=csrf_token]').attr('content');
    var stripe_key = $('meta[name=stripe_key]').attr('content');
    var delegate;
    var step = 1;
    var steps = 1;
    var fields;
    var attending = null;
    var accommodation = null;
    var options_costs = 0;
    var total_cost = null;
    var currency = 'gbp';
    var currency_denom = '&pound';
    var invoice = null;
    var submitted = false;

    if ($('select[name=date_id] option').length == 1) {
        date_id = $('select[name=date_id]').val();
    }

    window.onhashchange = function(e) {
        var hash = window.location.hash.substr(1);
        step = !isNaN(parseInt(hash)) && isFinite(hash) ? parseInt(hash) : 1;
        window.scrollTo(0, 0);

        $('.form-section').removeClass('active');
        $('#step-'+step).addClass('active');

        $('#step').text(step);
        $('.progress-bar').css('width', ((100/(steps+2))*step)+'%');
    };

    $('.form-control-file').on('change', function (e) {
        var button = $(this).parent().find('.upload-file');
        var errorText = $(this).parent().find('.file_upload_error');
        if(this.files[0] && (this.files[0].size/1024/1024) > 3) {
            errorText.text('The file must be no larger than 3Mb.').removeClass('hide');
            button.addClass('hide');
        } else {
            if($('.form-control-file')[0].files.length) {
                button.removeClass('hide');
            } else {
                button.addClass('hide');
            }
            errorText.text('').addClass('hide');
        }
    });

    // $('.change-uploaded-file').on('click', function (e) {
    //     e.preventDefault();

    //     var uploadedFileInfo = $(this).parent().parent();
    //     var fileUploadControls = uploadedFileInfo.prev('.upload_file_controls');

    //     uploadedFileInfo.find('.form-control-input').val('');
    //     uploadedFileInfo.addClass('hide');
    //     fileUploadControls.removeClass('hide');
    // });

    $('.remove-uploaded-file').on('click', function (e) {
        e.preventDefault();
        var $el = $(this);
        $el.text('removing...');
        var file = $(this).parent().parent().find('.form-control-input');
        var fileparts = file.val().split('/');
        var filename = fileparts[fileparts.length-1];
        var uploadedFileInfo = $(this).parent().parent();
        var fileUploadControls = uploadedFileInfo.prev('.upload_file_controls');
        $.ajax({
            url: api_url+'/uploads/'+event_id+'/'+$(this).data('fieldid')+'/'+delegate_id+'?key='+key.attr('content'),
            type: 'DELETE',
            processData: false,
            contentType: false,
            success: function(response) {
                file.val('');
                $el.text('remove');
                uploadedFileInfo.addClass('hide');
                fileUploadControls.removeClass('hide');
                fileUploadControls.find('.upload-file').addClass('hide');
            },
            error: function(response, s, v) {
                //
            }
        });

        var uploadedFileInfo = $(this).parent().parent();
        var fileUploadControls = uploadedFileInfo.prev('.upload_file_controls');

        uploadedFileInfo.addClass('hide');
        fileUploadControls.removeClass('hide');
    });

    $('.upload-file').on('click', function (e) {
        var $el = $(this);
        $el.text('Uploading...');
        var fileUploadControls = $(this).parent();
        var file = fileUploadControls.find('.form-control-file')[0].files[0];
        var errorText = fileUploadControls.find('.file_upload_error');
        var uploadedFileInfo = fileUploadControls.next('.uploaded_file_info');
        var hiddenInput = uploadedFileInfo.find('.form-control-input');

        if(file)
        {
            // upload file
            var formData = new FormData();
            formData.append('file', file);

            $.ajax({
                url: api_url+'/uploads/'+event_id+'?key='+key.attr('content'),
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function(response) {
                    // Hide the file upload controls
                    errorText.text('').addClass('hide');
                    fileUploadControls.addClass('hide');
                    if(response.file)
                    {
                        // Show the upload file info
                        hiddenInput.val(response.file);
                        uploadedFileInfo.find('.upload_file_info_name').html('<a href="'+response.file+'" target="_blank">View uploaded file</a> (opens in new window)');
                        uploadedFileInfo.removeClass('hide');

                        // Clear the file input
                        fileUploadControls.find('.form-control-file').val('');
                    }
                    $el.text('Upload');
                },
                error: function(response, s, v) {
                    if(response.responseText)
                    {
                        response = JSON.parse(response.responseText);
                        errorText.text(response.errors.file[0]).removeClass('hide');
                        $el.text('Upload');
                        return false;
                    }
                }
            });
        }
    });

    $.ajax({
        url: api_url+'/events/'+event_id+'?key='+key.attr('content'),
        type: 'GET',
        dataType: 'json',
        success: function(response){
            this_event = response.event;
            if(this_event.steps && this_event.steps.length)
            {
                steps = this_event.steps.length;
            }

            if(delegate_id)
            {

                $.ajax({
                    url: api_url+'/events/'+event_id+'/delegates/'+delegate_id+'?key='+key.attr('content'),
                    type: 'GET',
                    dataType: 'json',
                    success: function(response) {
                        delegate = response.delegate;
                        populateForm(delegate);
                        triggerValidation();
                        $('#submit-form').removeAttr('disabled');
                    },
                    error: function(data, i, s) {
                        //alert(i);
                    }
                });
            } else {
                if(date_id)
                {
                    $('select[name=date_id]').val(date_id);
                }
                triggerValidation();
            }
        },
        error: function(data, i, s) {
            //alert(i);
        }
    });

    $('#register .prev-step').on('click', function(e) {
        e.preventDefault();

        step--;
        window.location = '/registration#'+step;
        setCurrency();
    });

    $('#register .form-section form.step').on('submit', function(e) {

        var errorsList = $('.errors');
        errorsList.hide();

        e.preventDefault();

        if(step === 1 && attending === false) {
            // Not attending so we can skip to submitting the form.
            submitRegistrationNotAttending();
            return;
        }

        // handle directory fields
        $.each(this_event.steps, function( index, event_step ) {
            if(step == event_step.number && event_step.name == 'Directory' && this_event.settings.directory)
            {
                var delegate = {
                    biography: $('#biography').val(),
                    linkedin: $('#linkedin').val()
                };

                $.ajax({
                    url: api_url+'/delegates/'+delegate_id+'/biography?key='+key.attr('content'),
                    type: 'POST',
                    data: JSON.stringify(delegate),
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function(response) {

                        if($('#photo')[0].files[0])
                        {
                            // upload photo
                            var formData = new FormData();
                            formData.append('photo', $('#photo')[0].files[0]);

                            $.ajax({
                                url: api_url+'/delegates/'+delegate_id+'/profile/upload?key='+key.attr('content'),
                                type: 'POST',
                                data: formData,
                                processData: false,
                                contentType: false,
                                success: function(response) {
                                    if(response.delegate.photo) {
                                        $('#profile-image').attr('src', response.delegate.photo).removeClass('hide');
                                    }
                                },
                                error: function(response, s, v) {
                                    if(response.responseText)
                                    {
                                        response = JSON.parse(response.responseText);
                                        errorsList.find('ul').html('');
                                        $.each(response.errors, function(key, value) {
                                            errorsList.find('ul').append('<li>'+value+'</li>');
                                        });
                                        errorsList.show();
                                        return false;
                                    }
                                }
                            });
                        }
                    },
                    error: function(response, s, v) {
                        if(response.responseText)
                        {
                            response = JSON.parse(response.responseText);
                            errorsList.find('ul').html('');
                            $.each(response.errors, function(key, value) {
                                errorsList.find('ul').append('<li>'+value+'</li>');
                            });
                            errorsList.show();
                            return false;
                        }
                    }
                });
            }
        });

        if(validate()) {

            step++;

            setCurrency();

            if(step === steps+1) {

                populateConfirmation();

                var total = $('#confirm-registration').data('total');
                               
                // payment form (stripe.js)
                if(typeof this_event.settings.registration_fee !== 'undefined' && total > 0 && ! invoice)
                {

                    var codes = {};

                    if(this_event.steps && this_event.steps.length) {
                        $.each(this_event.steps, function( index, step ) {
                            $.each(step.fields, function( index, field ) {
                                if(field.type == 'code') {
                                    codes[field.id] =$('input[name=field_'+field.id+']').val();
                                }
                            });
                        });
                    }

                    var data = {
                        name: $('#firstname').val() + ' ' + $('#surname').val(),
                        email: $('#email').val(),
                        event_id: event_id,
                        date_id: date_id,
                        delegate_id: delegate_id,
                        amount: total,
                        codes: codes
                    };

                    /* register payment intent with stripe using event and delegate information */
                    $.ajax({
                        url: api_url+'/payments/intent/?key='+key.attr('content'),
                        type: 'POST',
                        data: JSON.stringify(data),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function(response) {

                            if(response.secret && response.amount > 0)
                            {

                                $('#payments-panel').show();
                                $('#confirm-registration').attr('disabled', false).html('Submit Payment &amp; Confirm Registration &nbsp;<i class="fa fa-credit-card"></i>');

                                // Create a Stripe client.
                                var stripe = Stripe(stripe_key, {
                                  betas: ['payment_intent_beta_3']
                                });

                                // Create an instance of Elements.
                                var elements = stripe.elements();

                                // Custom styling can be passed to options when creating an Element.
                                // (Note that this demo uses a wider set of styles than the guide below.)
                                var style = {
                                  base: {
                                    color: '#32325d',
                                    lineHeight: '18px',
                                    fontFamily: '"Open Sans",Helvetica,Arial,sans-serif',
                                    fontSmoothing: 'antialiased',
                                    fontSize: '15px',
                                    '::placeholder': {
                                      color: '#aab7c4'
                                    }
                                  },
                                  invalid: {
                                    color: '#fa755a',
                                    iconColor: '#fa755a'
                                  }
                                };

                                // Create an instance of the card Element.
                                var card = elements.create('card', {style: style});

                                $('#confirm-registration').data('secret', response.secret);
                                $('.amount-message').html(response.message);
                                $('.discount-message').html(response.discount_message);
                                $('.basket-total').html(currency_denom + parseFloat(response.amount).toFixed(2));


                                // Add an instance of the card Element into the `card-element` <div>.
                                card.mount('#card-element');

                                // set the name and email fields to match delegate
                                $('#cardholder-name').val($('input[name=firstname]').val() + ' ' + $('input[name=surname]').val());
                                $('#card-receipt_email').val($('input[name=email]').val());

                                // Handle real-time validation errors from the card Element.
                                card.addEventListener('change', function(event) {
                                  if (event.error) {
                                    $('#card-errors').html(event.error.message);
                                  } else {
                                    $('#card-errors').html('');
                                  }
                                });

                                // Handle form submission.
                                var form = document.getElementById('payment-form');
                                form.addEventListener('submit', function(event) {
                                  event.preventDefault();

                                  if (invoice) {
                                    submitRegistration();
                                    return;
                                  }
                                  
                                    //submitPayment(stripe, card);

                                    $('#confirm-registration').attr('disabled', true).html('Processing...&nbsp;<i class="fa fa-spinner fa-spin"></i>');

                                    var errorsList = $('.errors');
                                    errorsList.hide();

                                    var cardholderName = $('#cardholder-name').val();
                                    var cardReceiptEmail = $('#card-receipt_email').val();
                                    var cardButton = $('#confirm-registration');
                                    var clientSecret = cardButton.data('secret');

                                    var ownerInfo = {
                                        'owner': {
                                            'name': cardholderName,
                                            'email': cardReceiptEmail,
                                        }
                                    };

                                    /* action payment */
                                    stripe.handleCardPayment(clientSecret, card, { 
                                        source_data: ownerInfo, 
                                        receipt_email: cardReceiptEmail
                                    }).then(function(result) {
                                        if (result.error) {
                                            // Inform the user if there was an error.
                                            alert('Sorry, there was a problem processing your payment: '+ result.error.message + ' Please check the information you provided and try again.');
                                            $('#confirm-registration').attr('disabled', false).html('Submit Payment &amp; Confirm Registration &nbsp;<i class="fa fa-credit-card"></i>');
                                        } else {
                                            // Set the token to send to the api.
                                            submitRegistration(result.paymentIntent);
                                        }
                                    });

                                });

                            } else {
                                
                                var form = document.getElementById('payment-form');
                                form.addEventListener('submit', function(event) {
                                  event.preventDefault();
                                  submitRegistration();
                                }); 

                                if(response.refund)
                                {
                                    $('.refund-warning').html(response.message).show();
                                    $('.total-table').hide();
                                } else {
                                    $('.total-table').show();
                                    $('.refund-warning').html('').hide();
                                }

                                $('.basket-total').html(currency_denom + parseFloat(response.amount).toFixed(2));
                                $('.amount-message').html(response.message);
                                $('.discount-message').html(response.discount_message);
                                $('#confirm-registration').removeAttr('disabled').html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
                                $('#payments-panel').hide();
                            }
                        },
                        error: function(response) {
                            $('#payments-panel').hide();
                            if(response.responseText)
                            {
                                response = JSON.parse(response.responseText);
                                errorsList.find('ul').html('');
                                $.each(response.errors, function(key, value) {
                                    errorsList.find('ul').append('<li>'+value+'</li>');
                                });
                                errorsList.show();
                                $('#confirm-registration').attr('disabled', true).html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
                                return false;
                            }
                        }
                    });

                } else if(typeof this_event.settings.registration_fee !== 'undefined') {

                    var form = document.getElementById('payment-form');
                    form.addEventListener('submit', function(event) {
                      event.preventDefault();
                      submitRegistration();
                    });

                    $('#confirm-registration').removeAttr('disabled').html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
                    $('#payments-panel').hide();

                }

            } 

            if(step === steps+2 && typeof this_event.settings.registration_fee == 'undefined')
            {
                submitRegistration();
            } else {
                window.location = '/registration#'+step;
            }
            
        }

    });

    $('select[name=date_id]').on('change', function() {
        date_id = $(this).val();
        refreshConditionals();
        setCurrency();
    });

    function refreshConditionals() {
        $('select.has-conditions option').each(function () {
            if(typeof($(this).data('condition')) != 'undefined') {
                if ($(this).data('condition') != date_id) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            }
        });
        $('input.has-conditions').each(function () {
            if(typeof($(this).data('condition')) != 'undefined') {
                if ($(this).data('condition') != date_id) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            }
        });

        $('select.has-conditions option[data-condition]:selected').each(function () {
            if (! $(this).is(':visible')) {
                $(this).parent().val('');
            }
        });
        $('input.has-conditions[data-condition]:checked').each(function () {
            if (! $(this).is(':visible')) {
                $(this).prop('checked', false);
            }
        });
    }

    function setCurrency() {
        var selectedCurrency = $("select[name=date_id] option:selected").data('currency');
        currency = selectedCurrency ? selectedCurrency : 'gbp';
        currency_denom = currency == 'eur' ? '&euro;' : '&pound';
        
        $('select.has-conditions option[data-condition="'+date_id+'"]').each(function () {
            $(this).html($(this).html().replace('£', currency_denom));
            $(this).html($(this).html().replace('€', currency_denom));
        });
        $('.currency_denom').html(currency_denom);
    }

    $('#register input[name=attending]:radio').on('change', function() {

        var $this = $(this);
        var btn = $('#submit-form');
        var date_wrapper = $('#date-wrapper');

        if($(this).attr('id') == 'attending-yes') {
            btn.removeClass('btn-danger').addClass('btn-success');
            btn.find('span').text('Next');
            date_wrapper.removeClass('hide');
            attending = true;
            $('#form_group_not_attending_reason').fadeOut();
            $('textarea[name=not_attending_reason]').val('');
        } else {
            date_wrapper.addClass('hide');
            btn.removeClass('btn-danger').addClass('btn-danger');
            btn.find('span').text('Confirm Registration: Not Attending');
            attending = false;
            $('#form_group_not_attending_reason').fadeIn();
        }

    });

    $('#register input[name=payment_method]:radio').on('change', function() {
        if($(this).val() == 'invoice') {
            $('.stripe-payment').removeClass('show').addClass('hide');
            $('.invoice-payment').removeClass('hide').addClass('show');
            invoice = true;
            var form = document.getElementById('payment-form');
            form.addEventListener('submit', function(event) {
                event.preventDefault();
                submitRegistration();
            });
            $('#confirm-registration').removeAttr('disabled').html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
        } else {
            $('.stripe-payment').removeClass('hide').addClass('show');
            $('.invoice-payment').removeClass('show').addClass('hide');
            invoice = false;
            $('#confirm-registration').removeAttr('disabled').html('Submit Payment &amp; Confirm Registration &nbsp;<i class="fa fa-credit-card"></i>');
        }
    });

    function addGuest(field) {
        var list = field.find('.guest-list');
        var count = list.children().length + 1;
        list.append('<div id="guest-'+count+'" class="panel guest-panel"> \
            <div class="panel-heading"><div class="row"><div class="col-xs-8"><h5 class="panel-title">Guest '+(count)+'</h5></div><div class="col-xs-4 text-right"><a href="#" class="remove-guest" style="color: #ffffff"><i class="fa fa-remove"></i> Remove</a></div></div></div> \
            <div class="panel-body"> \
                <div class="row"> \
                    <div class="col-sm-2">\
                        <div class="form-group"> \
                            <label for="guest-title-'+count+'">Title *</label> \
                            <select name="guest['+count+'][title]" id="guest-title-'+count+'" class="form-control"> \
                                <option value="Mr">Mr</option> \
                                <option value="Ms">Ms</option> \
                                <option value="Mrs">Mrs</option> \
                                <option value="Miss">Miss</option> \
                                <option value="Dr">Dr</option> \
                                <option value="Other">Other</option> \
                            </select> \
                        </div> \
                    </div> \
                    <div class="col-sm-5">\
                        <div class="form-group"> \
                            <label for="guest-firstname-'+count+'">First Name *</label> \
                            <input type="text" name="guest['+count+'][firstname]" id="guest-firstname-'+count+'" class="form-control"> \
                        </div> \
                    </div> \
                    <div class="col-sm-5">\
                        <div class="form-group"> \
                            <label for="guest-surname-'+count+'">Surname *</label> \
                            <input type="text" name="guest['+count+'][surname]" id="guest-surname-'+count+'" class="form-control"> \
                        </div> \
                    </div> \
                </div> \
                <div class="row"> \
                    <div class="col-sm-6">\
                        <div class="form-group"> \
                            <label for="guest-email-'+count+'">Email Address *</label> \
                            <input type="email" name="guest['+count+'][email]" id="guest-email-'+count+'" class="form-control"> \
                        </div> \
                    </div> \
                    <div class="col-sm-6">\
                        <div class="form-group"> \
                            <label for="guest-phone-'+count+'">Contact Number *</label> \
                            <input type="text" name="guest['+count+'][phone]" id="guest-phone-'+count+'" class="form-control"> \
                        </div> \
                    </div> \
                </div> \
                <div class="row"> \
                    <div class="col-sm-6">\
                        <div class="form-group"> \
                            <label for="guest-dietary_requirements-'+count+'">Dietary Requirements *</label> \
                            <input type="text" name="guest['+count+'][dietary_requirements]" id="guest-dietary_requirements-'+count+'" class="form-control"> \
                        </div> \
                    </div> \
                    <div class="col-sm-6">\
                        <div class="form-group"> \
                            <label for="guest-access_requirements-'+count+'">Access Requirements</label> \
                            <input type="text" name="guest['+count+'][access_requirements]" id="guest-access_requirements-'+count+'" class="form-control"> \
                        </div> \
                    </div> \
                </div> \
            </div> \
        </div>');
    }

    $('.add-guest').on('click', function () {
        addGuest($(this).parent());
        if ($(this).parent().find('.guest-list').children().length == 10) {
            $(this).addClass('hide');
        } else {
            $(this).text('Add Another Guest');
        }
        refreshTotal();
    });
    $('.guest-list').on('click', '.remove-guest', function (e) {
        e.preventDefault();
        var guest = $(this).parents('.guest-panel');
        var list = guest.parent();
        guest.remove();
        if (! list.children().length) {
            list.parent().find('.add-guest').text('Add a Guest');
        }
        list.parent().find('.add-guest').removeClass('hide');
        refreshTotal();
    });

    function populateForm(delegate) {

        var date_wrapper = $('#date-wrapper');

        if(delegate)
        {
            if(delegate.attending === true) {
                $('#attending-yes').attr('checked', 'checked');
                date_wrapper.removeClass('hide');
                attending = true;
            }
            if(delegate.attending === false) {
                $('#attending-no').attr('checked', 'checked');
                $('#form_group_not_attending_reason').fadeIn();
                date_wrapper.addClass('hide');
                attending = false;
                var btn = $('#submit-form');
                btn.removeClass('btn-danger').addClass('btn-danger');
                btn.find('span').text('Confirm Registration: Not Attending');
            }
            
            if(delegate.date_id !== null) {
                $('select[name=date_id]').val(delegate.date_id);
                date_id = delegate.date_id;
            }
            $('input[name=attending]').val(delegate.attending);
            $('input[name=not_attending_reason]').val(delegate.not_attending_reason);
            $('input[name=date_id]').val(delegate.date_id);
            $('input[name=firstname]').val(delegate.firstname);
            $('input[name=surname]').val(delegate.surname);
            $('input[name=email]').val(delegate.email);
            $('input[name=phone]').val(delegate.phone);

            // biography
            $('textarea[name=biography]').val(delegate.biography);
            $('input[name=linkedin]').val(delegate.linkedin);

            if(delegate.photo) $('.profile-image').attr('src', delegate.photo).removeClass('hide');
        }

        if(this_event.steps && this_event.steps.length)
        {
            $.each(this_event.steps, function( index, step ) {
                $.each(step.fields, function( index, field ) {
                    switch(field.type)
                    {

                        case 'text':
                        case 'code':
                            $('input[name=field_'+field.id+']').val(delegate.field_responses[field.name]);
                            break;

                         case 'textarea':
                            $('textarea[name=field_'+field.id+']').val(delegate.field_responses[field.name]);
                            break;

                        case 'select':
                            var fieldEditing = $('select[name=field_'+field.id+']');
                            fieldEditing.val(delegate.field_responses[field.name]);

                            fieldEditing.find('option').each(function () {
                                if (this.value.indexOf('(sold out') !== -1) {
                                    var amendedSelection = delegate.field_responses[field.name]+' (sold out)';
                                    var amendedOption = this.value.replace(' (sold out)', '');

                                    if (this.value == amendedSelection) {
                                        fieldEditing.val(this.value);
                                        this.text = amendedOption;
                                        $(this).prop('disabled', false);
                                    } else {
                                        $(this).prop('disabled', true);
                                    }
                                }
                            });

                            // $('select[name=field_'+field.id+']').val(delegate.field_responses[field.name]);
                            break;

                        case 'multiselect':
                             $('select[name=field_'+field.id+']').val(delegate.field_responses[field.name]);
                             break;

                        case 'radio':
                            $('input[name=field_'+field.id+'][value="'+delegate.field_responses[field.name]+'"]').prop('checked',true);
                            break;

                        case 'checkbox':
                            $('input[name=field_'+field.id+'][value="'+delegate.field_responses[field.name]+'"]').prop('checked',true);
                            break;

                        case 'score':
                            $('input[name=field_'+field.id+'][value="'+delegate.field_responses[field.name]+'"]').prop('checked',true);
                            break;

                        case 'multiscore':
                            var i = 0;
                            if($.isArray(delegate.field_responses[field.name]))
                            {
                                $.each(delegate.field_responses[field.name], function(value, score)
                                {
                                    $('input[name=field_'+field.id+'_'+i+'][value="'+score+'"]').prop('checked',true);
                                    i++;
                                });
                            }
                            break;

                        case 'file':
                            $('input[name=field_'+field.id+']').val(delegate.field_responses[field.name]);
                            if (delegate.field_responses[field.name]) {
                                var wrapper = $('#form_group_'+field.id);
                                wrapper.find('.upload_file_controls').addClass('hide');
                                wrapper.find('.uploaded_file_info').removeClass('hide');
                                wrapper.find('.uploaded_file_info .upload_file_info_name').html('<a href="'+$('input[name=field_'+field.id+']').val()+'" target="_blank">View uploaded file</a> (opens in new window)');
                            }
                            break;
                            
                        case 'guest':
                            var guests = JSON.parse(delegate.field_responses[field.name]);
                            var parent = $('#field_'+field.id);
                            var list = $('#field_'+field.id).find('.guest-list');
                            for (var i = 0; i < guests.length; i++) {
                                addGuest(parent);
                                list.find('select[name="guest['+(i+1)+'][title]"]').val(guests[i].title);
                                list.find('input[name="guest['+(i+1)+'][firstname]"]').val(guests[i].firstname);
                                list.find('input[name="guest['+(i+1)+'][surname]"]').val(guests[i].surname);
                                list.find('input[name="guest['+(i+1)+'][email]"]').val(guests[i].email);
                                list.find('input[name="guest['+(i+1)+'][phone]"]').val(guests[i].phone);
                                list.find('input[name="guest['+(i+1)+'][dietary_requirements]"]').val(guests[i].dietary_requirements);
                                list.find('input[name="guest['+(i+1)+'][access_requirements]"]').val(guests[i].access_requirements);
                            }
                            if (guests.length == 10) {
                                list.parent().find('.add-guest').addClass('hide');
                            } else if (guests.length > 1) {
                                list.parent().find('.add-guest').text('Add Another Guest');
                            }
                            break;
                    }
                });
            });
        }
        
        refreshConditionals();
        setCurrency();
        refreshTotal();
    }

    function triggerValidation() {

        if(this_event.steps && this_event.steps.length)
        {
            $.each(this_event.steps, function( index, event_step ) {

                $.each(event_step.fields, function( index, field ) {

                    if(field.validation)
                    {
                        $.each(field.validation, function( type, field_id ) {

                            switch(type)
                            {

                                case 'show_with':

                                    // hide by default
                                    $('#form_group_'+field.id).hide();
                                    $('#confirm_form_group_'+field.id).hide();

                                    if($('#field_'+field_id).val() && $('#field_'+field_id).val() !== '') {
                                        $('#form_group_'+field.id).parent().fadeIn();
                                        $('#confirm_form_group_'+field.id).fadeIn();
                                    }

                                    // add listener
                                    $('input[name=field_'+field_id+']').on('keyup', function() {
                                        if($('input[name=field_'+field_id+']').val() !== '') {
                                            $('#form_group_'+field.id).parent().fadeIn();
                                            $('#confirm_form_group_'+field.id).fadeIn();
                                        } else {
                                            $('#form_group_'+field.id).parent().fadeOut();
                                            $('#confirm_form_group_'+field.id).fadeOut();
                                        }
                                    });

                                    break;

                                case 'show_if_checked':

                                    // hide by default
                                    $('#form_group_'+field.id).parent().hide();
                                    $('#confirm_form_group_'+field.id).hide();

                                    // show if already true (based on populated form)
                                    if($('input[name=field_'+field_id.field_id+']:checked').val() == field_id.value) {
                                        $('#form_group_'+field.id).parent().fadeIn();
                                        $('#confirm_form_group_'+field.id).fadeIn();
                                    }

                                    // add listener
                                    $('input[name=field_'+field_id.field_id+']:radio').on('change', function() {
                                        if($('input[name=field_'+field_id.field_id+']:checked').val() == field_id.value) {
                                            $('#form_group_'+field.id).parent().fadeIn();
                                            $('#confirm_form_group_'+field.id).fadeIn();
                                        } else {
                                            $('#form_group_'+field.id).parent().fadeOut();
                                            $('#confirm_form_group_'+field.id).fadeOut();
                                            $('#field_'+field.id).prop('checked', false);
                                        }
                                    });
                                    break;

                                case 'show_if_selected':

                                    // hide by default
                                    $('#form_group_'+field.id).parent().hide();
                                    $('#confirm_form_group_'+field.id).hide();

                                    // show if already true (based on populated form)
                                    if(typeof field_id.value === 'string')
                                    {
                                        if($('select[name=field_'+field_id.field_id+']').val() == field_id.value) {
                                            $('#form_group_'+field.id).parent().fadeIn();
                                            $('#confirm_form_group_'+field.id).fadeIn();
                                        } else {
                                            $('#form_group_'+field.id).parent().fadeOut();
                                            $('#confirm_form_group_'+field.id).fadeOut();
                                            $('#field_'+field.id).prop('checked', false);
                                            $('select[name=field_'+field.id+']').val('');
                                        }
                                    } else {
                                        $('#form_group_'+field.id).parent().fadeOut();
                                        $('#confirm_form_group_'+field.id).fadeOut();
                                        //$('select[name=field_'+field.id+']').val('');
                                        $.each(field_id.value, function( key, val ) {
                                            if($('select[name=field_'+field_id.field_id+']').val() == val) {
                                                $('#form_group_'+field.id).parent().fadeIn();
                                                $('#confirm_form_group_'+field.id).fadeIn();
                                            } else {
                                                $('select[name=field_'+field.id+']').val('');
                                            }
                                        });
                                    }

                                    // add listener
                                    $('select[name=field_'+field_id.field_id+']').on('change', function() {
                                        if(typeof field_id.value === 'string')
                                        {
                                            if($('select[name=field_'+field_id.field_id+']').val() == field_id.value) {
                                                $('#form_group_'+field.id).parent().fadeIn();
                                                $('#confirm_form_group_'+field.id).fadeIn();
                                            } else {
                                                $('#form_group_'+field.id).parent().fadeOut();
                                                $('#confirm_form_group_'+field.id).fadeOut();
                                                $('#field_'+field.id).prop('checked', false);
                                                $('select[name=field_'+field.id+']').val('');
                                            }
                                        } else {
                                            $('#form_group_'+field.id).parent().fadeOut();
                                            $('#confirm_form_group_'+field.id).fadeOut();
                                            $.each(field_id.value, function( key, val ) {
                                                if($('select[name=field_'+field_id.field_id+']').val() == val) {
                                                    $('#form_group_'+field.id).parent().fadeIn();
                                                    $('#confirm_form_group_'+field.id).fadeIn();
                                                } else {
                                                    $('select[name=field_'+field.id+']').val('');
                                                }
                                            });
                                        }
                                    });
                                    break;
                            }
                        });
                    }

                });

            });
        }
    }

    function populateConfirmation() {

        $('#confirm-name').text($('input[name=firstname]').val()+' '+$('input[name=surname]').val());
        $('#confirm-phone').text($('input[name=phone]').val());
        $('#confirm-email').text($('input[name=email]').val());
        $('#confirm-date').text($("select[name=date_id] option:selected").text());

        // directory
        $('#confirm-biography').text($('textarea[name=biography]').val());
        $('#confirm-linkedin').text($('input[name=linkedin]').val());

        triggerValidation();

        if(this_event.steps && this_event.steps.length)
        {
            $.each(this_event.steps, function( index, step ) {
                $.each(step.fields, function( index, field ) {
                    switch(field.type)
                    {
                        case 'text':
                        case 'code':
                            $('#confirm-field_'+field.name).text($('input[name=field_'+field.id+']').val());
                            break;

                        case 'textarea':
                            $('#confirm-field_'+field.name).text($('textarea[name=field_'+field.id+']').val());
                            break;

                        case 'select':
                            $('#confirm-field_'+field.name).text($('select[name=field_'+field.id+']').val());
                            break;

                        case 'multiselect':
                            $('#confirm-field_'+field.name).text($('select[name=field_'+field.id+']').val());
                            break;

                        case 'radio':
                            $('#confirm-field_'+field.name).text($('input[name=field_'+field.id+']:checked').val());
                            break;

                        case 'checkbox':
                            $('#confirm-field_'+field.name).text($('input[name=field_'+field.id+']:checked').val());
                            break;

                        case 'score':
                            $('#confirm-field_'+field.name).text($('input[name=field_'+field.id+']:checked').val());
                            break;

                        case 'multiscore':
                            var i = 0;
                            response = '';
                            $.each(field.options, function(value, score)
                            {
                                response = response + '<br>' + $('input[name=field_'+field.id+'_'+i+']:checked').val();
                                i++;
                            });
                            $('#confirm-field_'+field.name).html(response);
                            break;

                        case 'file':
                            if($('input[name=field_'+field.id+']').val()) {
                                $('#confirm-field_'+field.name).html('<a href="'+$('input[name=field_'+field.id+']').val()+'" target="_blank">View uploaded file</a> (opens in new window)');
                            } else {
                                $('#confirm-field_'+field.name).text('n/a');
                            }
                            
                            break;
                        
                        case 'guest':
                            var list = $('#field_'+field.id).find('.guest-list');
                            var response = '';
                            for (var i = 1; i <= list.children().length; i++) {
                                response = response + '<div class="well">';
                                response = response + list.find('select[name="guest['+i+'][title]"]').val()+' '+list.find('input[name="guest['+i+'][firstname]"]').val()+' '+list.find('input[name="guest['+i+'][surname]"]').val()+'<br>';
                                response = response + '<strong>Email:</strong> '+list.find('input[name="guest['+i+'][email]"]').val()+' &nbsp; <strong>Phone:</strong> '+list.find('input[name="guest['+i+'][phone]"]').val()+'<br>';
                                response = response + '<strong>Dietary Requirements:</strong> '+list.find('input[name="guest['+i+'][dietary_requirements]"]').val()+'<br>';
                                response = response + '<strong>Access Requirements:</strong> '+list.find('input[name="guest['+i+'][access_requirements]"]').val()+'<br>';
                                response = response + '</div>';
                            }
                            $('#confirm-field_'+field.name).html(response);
                            break;
                    }
                });
            });
        }

    }

    function validate() {

        var errorsList = $('.errors');
        errorsList.hide();

        step = typeof step !== 'undefined' ? step : this.step;

        var errors = [];

        switch(step) {
            case 1:
                if(attending === null) errors.push('Please indicate whether or not you can attend.');
                if($('input[name=attending]').val() == 'No' && ! $('textarea[name=not_attending_reason]').val()) errors.push('Please tell us why you will not be attending.');
                if(! $('input[name=firstname]').val()) errors.push('Your firstname is required.');
                if(! $('input[name=surname]').val()) errors.push('Your surname is required.');
                if(! $('input[name=email]').val()) errors.push('Your email address is required.');

                var email = $('input[name=email]').val();

                if (this_event.settings.no_personal_emails) {
                    if ((email.indexOf('hotmail') !== -1) || (email.indexOf('yahoo') !== -1) || (email.indexOf('gmail') !== -1) || (email.indexOf('outlook') !== -1)) {
                        errors.push('Please use your company email address, not personal.');
                    }
                }

                //if(! $('input[name=phone]').val()) errors.push('Your contact number is required.');
                if(! $("select[name=date_id] option:selected").val()) errors.push('Select the date you would like to attend.');
                break;
            default:
                break;
        }

        if(this_event.steps && this_event.steps.length)
        {
            $.each(this_event.steps, function( index, event_step ) {
                if(event_step.number == step)
                {
                    $.each(event_step.fields, function( index, field ) {
                        switch(field.type)
                        {
                            case 'text':
                            case 'code':
                                if(field.required && !$('input[name=field_'+field.id+']').val()) errors.push(field.label + ' is required.');
                                break;

                             case 'textarea':
                                if(field.required && !$('textarea[name=field_'+field.id+']').val()) errors.push(field.label + ' is required.');
                                break;

                            case 'select':
                            case 'multiselect':
                                if(field.required && !$('select[name=field_'+field.id+']').val()) errors.push(field.label + ' is required.');
                                break;

                            case 'radio':
                            case 'checkbox':
                                if(field.required && !$('input[name=field_'+field.id+']:checked').val()) errors.push(field.label + ' is required.');
                                break;

                            case 'score':
                                if(field.required && !$('input[name=field_'+field.id+']:checked').val()) errors.push(field.label + ' score required.');
                                break;

                            case 'multiscore':
                                var i = 0;
                                $.each(field.options, function(value, score)
                                {
                                    if(field.required && !$('input[name=field_'+field.id+'_'+i+']:checked').val()) errors.push(field.label + ' (' + value + ') score required.');
                                    i++;
                                });
                                break;

                            case 'file':
                                if(field.required && !$('input[name=field_'+field.id+']').val()) errors.push(field.label + ' is required.');
                                break;
                            
                            case 'guest':
                                var guests = [];
                                var list = $('#field_'+field.id).find('.guest-list');
                                for (var i = 1; i <= list.children().length; i++) {
                                    if (
                                        ! list.find('select[name="guest['+i+'][title]"]').val() ||
                                        ! list.find('input[name="guest['+i+'][firstname]"]').val() ||
                                        ! list.find('input[name="guest['+i+'][surname]"]').val() ||
                                        ! list.find('input[name="guest['+i+'][email]"]').val() ||
                                        ! list.find('input[name="guest['+i+'][phone]"]').val() ||
                                        ! list.find('input[name="guest['+i+'][dietary_requirements]"]').val()
                                    ) {
                                        errors.push('Please ensure all guest information in complete.');
                                        break;
                                    }
                                }
                                break;
                        }

                        // check for field specific validation
                        if(field.validation)
                        {

                            $.each(field.validation, function( type, field_id ) {

                                switch(type)
                                {
                                    case 'required_with':
                                        if(!$('#field_'+field.id).val() && $('#field_'+field_id).val()) errors.push($('#field_'+field.id).parent().children('label').text()+' is required with '+$('#field_'+field_id).parent().children('label').text()+'.');
                                        break;

                                    case 'required_if':

                                        if(field.type == 'radio' || field.type == 'checkbox')
                                        {

                                            if(typeof field_id.value === 'string')
                                            {
                                                if(!$('#field_'+field.id+':checked').val() && $('#field_'+field_id.field_id).val() == field_id.value) errors.push(field.label+' is a required field.');
                                            } else {
                                                $.each(field_id.value, function( key, val ) {
                                                    if(!$('#field_'+field.id+':checked').val() && $('#field_'+field_id.field_id).val() == val) errors.push(field.label+' is a required field.');
                                                }); 
                                            }
                                        } else {

                                            if(typeof field_id.value === 'string')
                                            {
                                                if(!$('#field_'+field.id).val() && $('#field_'+field_id.field_id).val() == field_id.value) errors.push($('#field_'+field.id).parent().children('label').text()+' is a required field.');
                                            } else {
                                                $.each(field_id.value, function( key, val ) {
                                                    if(!$('#field_'+field.id).val() && $('#field_'+field_id.field_id).val() == val) errors.push($('#field_'+field.id).parent().children('label').text()+' is a required field.');
                                                });
                                            }
                                        }
                                        break;

                                    case 'required_if_checked':
                                        if(field.type == 'radio' || field.type == 'checked')
                                        {
                                            if(!$('#field_'+field.id+':checked').val() && $('#field_'+field_id.field_id+':checked').val() == field_id.value) errors.push($('#field_'+field.id).parent().parent().parent().children('label').text()+' is a required field.');
                                            break;
                                        } else {
                                            if(!$('#field_'+field.id).val() && $('#field_'+field_id.field_id+':checked').val() == field_id.value) errors.push($('#field_'+field.id).parent().children('label').text()+' is a required field.');
                                            break;
                                        }

                                    case 'not_equal_to':
                                        if($('#field_'+field.id).val() && $('#field_'+field_id).val() == $('#field_'+field.id).val()) errors.push($('#field_'+field.id).parent().children('label').text()+' cannot be the same as '+$('#field_'+field_id).parent().children('label').text());
                                        break;
                                }
                            });
                        }

                    });
                }
            });
        }

        if(errors.length) {
            errorsList.find('ul').html('');
            for (var i = 0; i < errors.length; i++) {
                errorsList.find('ul').append('<li>'+errors[i]+'</li>');
            }
            errorsList.show();
            return false;
        } else {
            refreshTotal();
        }
        
        errorsList.hide();
        return true;
    }

    function refreshTotal() {
        if(typeof this_event.settings.registration_fee !== 'undefined') {
            total = this_event.settings.registration_fee;
            basket_lines = [];

            // set total basket based on calculations above
            $.each(this_event.steps, function( index, event_step ) {
                $.each(event_step.fields, function( index, field ) {

                    if(typeof field.options_values === 'object' && field.options_values !== null)
                    {
                        switch(field.type)
                        {
                                case 'select':
                                $.each(field.options_values, function(key, value) {
                                    if(key == $('select[name=field_'+field.id+']').val()) {
                                        total += parseFloat(value);
                                        basket_lines.push(value);
                                    }
                                });
                                break;

                                case 'multiselect':
                                $.each(field.options_values, function(key, value) {
                                    if($('select[name=field_'+field.id+']').val() && $('select[name=field_'+field.id+']').val().isArray()) {
                                        $('select[name=field_'+field.id+']').val().each(function(option) {
                                            if(key == option.val()) {
                                                total += parseFloat(value);
                                                basket_lines.push(value);
                                            }
                                        });
                                    }
                                });
                                break;

                                case 'radio':
                                $.each(field.options_values, function(key, value) {
                                    if(key == $('input[name=field_'+field.id+']:checked').val()) {
                                        total += parseFloat(value);
                                        basket_lines.push(value);
                                    }
                                });
                                break;

                                default:
                                break;
                        }
                    }
                });
            });
            
            var guestCount = 1;

            $.each(this_event.steps, function( index, event_step ) {
                var guestFields = event_step.fields.filter(function (field) {
                    return field.type == 'guest';
                });
                $.each(guestFields, function( index, field ) {
                    guestCount += $('#field_'+field.id).find('.guest-list').children().length;
                });
            });

            total = total * guestCount;

            $('.basket-total').html(currency_denom + parseFloat(total).toFixed(2));
            $('#confirm-registration').data('total', parseFloat(total).toFixed(2) * 100);

            return total;
        }

        return 0;
    }

    function submitRegistration(paymentIntent) {
        if (submitted) return;
        submitted = true;
        $('#confirm-registration').attr('disabled', true).html('Processing...&nbsp;<i class="fa fa-spinner fa-spin"></i>');

        var errorsList = $('.errors');
        errorsList.hide();

        // Prep delegate info for sending to API for updating.
        var delegate = {
            firstname: $('input[name=firstname]').val(),
            surname: $('#surname').val(),
            email: $('#email').val(),
            phone: $('#phone').val(),
            additional_information: $('#additional_information').val(),
            dietary_requirements: $('#dietary_requirements').val(),
            event_id: event_id
        };

        $.ajax({
            url: (delegate_id) ? api_url+'/delegates/'+delegate_id+'?key='+key.attr('content') : api_url+'/delegates/?key='+key.attr('content'),
            type: 'POST',
            data: JSON.stringify(delegate),
            dataType: 'json',
            contentType: 'application/json',
            success: function(response) {

                var field_responses = {};

                if(this_event.steps && this_event.steps.length)
                {
                    $.each(this_event.steps, function( index, step ) {
                        $.each(step.fields, function( index, field ) {
                            switch(field.type)
                            {
                                case 'text':
                                case 'code':
                                    field_responses[field.name] = $('input[name=field_'+field.id+']').val();
                                    break;

                                 case 'textarea':
                                    field_responses[field.name] = $('textarea[name=field_'+field.id+']').val();
                                    break;

                                case 'select':
                                    field_responses[field.name] = $('select[name=field_'+field.id+']').val();
                                    break;

                                case 'multiselect':
                                    field_responses[field.name] = $('select[name=field_'+field.id+']').val();
                                    break;

                                case 'radio':
                                    field_responses[field.name] = $('input[name=field_'+field.id+']:checked').val();
                                    break;

                                case 'checkbox':
                                    field_responses[field.name] = $('input[name=field_'+field.id+']:checked').val();
                                    break;

                                case 'score':
                                    field_responses[field.name] = $('input[name=field_'+field.id+']:checked').val();
                                    break;

                                case 'multiscore':
                                    var i = 0;
                                    field_responses[field.name] = [];
                                    $.each(field.options, function(value, score)
                                    {
                                        field_responses[field.name][i] = $('input[name=field_'+field.id+'_'+i+']:checked').val();
                                        i++;
                                    });
                                    break;

                                case 'file':
                                    field_responses[field.name] = $('input[name=field_'+field.id+']').val();
                                    break;

                                case 'guest':
                                    var guests = [];
                                    var list = $('#field_'+field.id).find('.guest-list');
                                    for (var i = 1; i <= list.children().length; i++) {
                                        guests.push({
                                            title: list.find('select[name="guest['+i+'][title]"]').val(),
                                            firstname: list.find('input[name="guest['+i+'][firstname]"]').val(),
                                            surname: list.find('input[name="guest['+i+'][surname]"]').val(),
                                            email: list.find('input[name="guest['+i+'][email]"]').val(),
                                            phone: list.find('input[name="guest['+i+'][phone]"]').val(),
                                            dietary_requirements: list.find('input[name="guest['+i+'][dietary_requirements]"]').val(),
                                            access_requirements: list.find('input[name="guest['+i+'][access_requirements]"]').val(),
                                        });
                                    }
                                    field_responses[field.name] = guests;
                                    break;
                            }
                        });
                    });
                }

                // Prep responses
                var eventPrefs = {
                    attending: attending,
                    date_id: $('#date_id').val(),
                    field_responses: field_responses,
                    paymentInformation: paymentIntent,
                    invoice: invoice,
                    invoice_total: refreshTotal(),
                };

                $.ajax({
                    url: api_url+'/events/'+event_id+'/delegates/'+response.delegate.id+'?key='+key.attr('content'),
                    type: 'POST',
                    data: JSON.stringify(eventPrefs),
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function(response) {
                        // Log the delegate in.
                        $.ajax({
                            url: '/loginviatoken',
                            type: 'POST',
                            data: JSON.stringify({'_token': csrf_token, 'token': response.delegate.token}),
                            dataType: 'json',
                            contentType: 'application/json',
                            success: function(response) {
                                $('#nav-register-button').hide();
                                $('#nav-login-button').hide();
                            }
                        });

                        step = steps+2;
                        $('#success-title').html('Registration confirmed');
                        $('.success-firstname').text($('input[name=firstname]').val());
                        $('.success-email').text($('input[name=email]').val());
                        $('#success-attending').show();
                        window.location = '/registration#'+step;
                        $('#confirm-registration').removeAttr('disabled').html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
                    },
                    error: function(response) {
                        if(response.responseText)
                        {
                            response = JSON.parse(response.responseText);
                            var errorsList = $('.errors');
                            errorsList.find('ul').html('');
                            $.each(response.errors, function(key, value) {
                                errorsList.find('ul').append('<li>'+value+'</li>');
                            });
                            errorsList.show();
                            $('#confirm-registration').attr('disabled', false).html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
                            return false;
                        }
                        $('#confirm-registration').attr('disabled', false).html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
                        submitted = false;
                    }
                });
            },
            error: function(response, s, v) {
                if(response.responseText)
                {
                    response = JSON.parse(response.responseText);
                    errorsList.find('ul').html('');
                    $.each(response.errors, function(key, value) {
                        errorsList.find('ul').append('<li>'+value+'</li>');
                    });
                    errorsList.show();
                    $('#confirm-registration').attr('disabled', false).html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
                    return false;
                }
                $('#confirm-registration').attr('disabled', false).html('Confirm Registration <i class="fa fa-thumbs-up"></i>');
                submitted = false;
            }
        });
    }

    function submitRegistrationNotAttending() {

        var errorsList = $('.errors');
        errorsList.hide();

        $('#submit-form').attr('disabled',true).text('Please wait...');

        var delegate = {
            firstname: $('input[name=firstname]').val(),
            surname: $('#surname').val(),
            email: $('#email').val(),
            phone: $('#phone').val(),
            event_id: event_id
        };

        var eventPrefs = {
            attending: attending,
            not_attending_reason: $('textarea[name=not_attending_reason]').val()
        };

        $.ajax({
            url: (delegate_id) ? api_url+'/delegates/'+delegate_id+'?key='+key.attr('content') : api_url+'/delegates/?key='+key.attr('content'),
            type: 'POST',
            data: JSON.stringify(delegate),
            dataType: 'json',
            contentType: 'application/json',
            success: function(response) {
                $.ajax({
                    url: api_url+'/events/'+event_id+'/delegates/'+response.delegate.id+'?key='+key.attr('content'),
                    type: 'POST',
                    data: JSON.stringify(eventPrefs),
                    dataType: 'json',
                    contentType: 'application/json',
                    success: function(response) {
                        // Log the delegate in.
                        $.ajax({
                            url: '/loginviatoken',
                            type: 'POST',
                            data: JSON.stringify({'_token': csrf_token, 'token': response.delegate.token}),
                            dataType: 'json',
                            contentType: 'application/json',
                            success: function(response) {
                                $('#nav-register-button').hide();
                                $('#nav-login-button').hide();
                            }
                        });

                        step = steps+2;
                        $('#success-title').html('Non-attendance confirmed');
                        $('.success-firstname').text($('input[name=firstname]').val());
                        $('.success-email').text($('input[name=email]').val());
                        $('#success-not-attending').show();
                        window.location = '/registration#'+step;
                        $('#submit-form').removeAttr('disabled', true).text('Confirm Registration: Not Attending');
                    },
                    error: function(response) { 
                        if(response.responseText)
                        {
                            response = JSON.parse(response.responseText);
                            errorsList.find('ul').html('');
                            $.each(response.errors, function(key, value) {
                                errorsList.find('ul').append('<li>'+value+'</li>');
                            });
                            errorsList.show();
                            return false;
                        }
                    }
                });
            },
            error: function(response) {
                if(response.responseText)
                {
                    response = JSON.parse(response.responseText);
                    errorsList.find('ul').html('');
                    $.each(response.errors, function(key, value) {
                        errorsList.find('ul').append('<li>'+value+'</li>');
                    });
                    errorsList.show();
                    return false;
                }
            }
        });
    }
});

//# sourceMappingURL=register.js.map
